import DocViewer from "react-doc-viewer";
import dox from "./assets/FQAs.pdf";
import FileViewer from 'react-file-viewer';
// // import { CustomErrorComponent } from 'custom-error';
import{ PDFRenderer, PNGRenderer,MSDocRenderer } from "react-doc-viewer";
import "./explore.css";
// const file = 'http://example.com/image.png'
// const type = 'pdf'
function Explore() {
//     const onError=(e)=>{
//         console.log(e)
//     }
//     return <FileViewer
//     fileType={type}
//     filePath={dox}
//     // errorComponent={CustomErrorComponent}
//     onError={onError}/>;
  const docs = [
    { 
        fileType:"application/pdf",        
        // fileType:"application/vnd.openxmlformats-officedocument.wordprocessingml.document",        
        uri: dox}, // Local File
  ];
  return <DocViewer documents={docs} 
  config={{
    header: {
     disableHeader: true,
     disableFileName: true,
     retainURLParams: true
    }
   }} 
   weight={2}
  pluginRenderers={[PDFRenderer, PNGRenderer]}
  />;
// //   return <DocViewer documents={docs}
// //   pluginRenderers={[MSDocRenderer]}

// //   />;
}
export default Explore;